import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/********************************************************************************
 * Copyright (c) 2020 TypeFox and others
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
import { useContext } from 'react';
import { Box, Typography, Select, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MainContext } from '../../context';
import { MONO_FONT } from '../../default/theme';
import { DeleteIconButton } from '../delete-icon-button';
import { TagChip } from '../page-primitives';
import { UserAvatar } from '../user-avatar';
import { NamespaceDetailConfigContext } from './namespace-detail-config';
// Same row anatomy as the trusted publisher list.
// Single line at every width: the name column truncates and the controls shrink.
const MemberRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
        gap: theme.spacing(1),
        padding: theme.spacing(1.5, 1.25)
    }
}));
export const NamespaceMemberRow = props => {
    const equalUser = (user1, user2) => {
        return user1?.loginName === user2?.loginName && user1?.provider === user2?.provider;
    };
    const memberUser = props.member.user;
    const context = useContext(MainContext);
    const { fixSelf } = useContext(NamespaceDetailConfigContext);
    const contextUser = context.user;
    return (_jsxs(MemberRow, { children: [_jsx(UserAvatar, { user: memberUser, sx: {
                    width: '2.5rem',
                    height: '2.5rem',
                    fontSize: '0.875rem',
                    flexShrink: 0
                } }), _jsxs(Box, { sx: { flex: 1, minWidth: 0 }, children: [_jsx(Typography, { noWrap: true, sx: { fontSize: '0.875rem', fontWeight: 700, lineHeight: 1.2 }, children: memberUser.fullName ?? memberUser.loginName }), _jsx(Typography, { noWrap: true, sx: {
                            fontSize: '0.78125rem',
                            color: 'text.disabled',
                            fontFamily: MONO_FONT,
                            mt: '0.125rem'
                        }, children: memberUser.loginName })] }), fixSelf && equalUser(memberUser, contextUser) ? (_jsx(TagChip, { accent: true, children: "Owner" })) : (_jsxs(Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: { xs: '0.5rem', sm: '0.8125rem' },
                    ml: 'auto',
                    flexShrink: 0
                }, children: [_jsxs(Select, { variant: 'outlined', size: 'small', sx: {
                            fontSize: { xs: '0.75rem', sm: '0.8125rem' },
                            fontWeight: 600,
                            '& .MuiSelect-select': {
                                py: { xs: '0.3125rem', sm: '0.53125rem' },
                                pl: { xs: '0.625rem', sm: '0.875rem' }
                            }
                        }, value: props.member.role, onChange: (event) => props.onChangeRole(event.target.value), children: [_jsx(MenuItem, { value: 'contributor', children: "Contributor" }), _jsx(MenuItem, { value: 'owner', children: "Owner" })] }), _jsx(DeleteIconButton, { title: 'Remove member', "aria-label": `Remove ${memberUser.loginName}`, onClick: () => props.onRemoveUser() })] }))] }));
};
//# sourceMappingURL=namespace-member-row.js.map